import { Layout } from 'antd';
import React from 'react';
import CreateSubscription from '../subscription/CreateSubscription';
import { useParams } from 'react-router-dom';

const { Content } = Layout;

export default function SubscriptionCheckoutPage() {
    const { planCode } = useParams();
    return (
        <Content className="general-layout-content">
            <CreateSubscription
                className="checkout"
                selectedPlanCode={planCode}
                title="Review & Confirm your Plan"
                buttonLabel="Place order"
                redirectTo="/subscription/plans"
            />
        </Content>
    );
}
